module.exports = __webpack_public_path__ + "static/img/VariCut-logo.19171fce.png";